import React, { useState, useEffect, useRef } from "react";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import{ earnRewardInIpl, GetIplBoosterList } from "../../../apis/iplBattle"
import { Images, ipl_BoosterDuration } from "../../../helpers/helpers";
import { logPageView } from "../../../components/analytics";

const CricketGame = (props) => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
    const playClick = useAudio();
  // const [score, setScore] = useState(0);
  const score = props?.score;
  const setScore = props?.setScore;
  const setBallCount = props?.setBallCount;
  const ballCount = props?.ballCount;
  const setIsGameActive = props?.setIsGameActive;
  const displaySetScore = props?.setDiplaySetScore
  const   iplBoosterPopup= props?.iplBoosterPopup ;
  const setIplBoosterPopup=props?.setIplBoosterPopup;
  const SquadList = watchScreen?.squad_list_ipl;
  const ComboPercent = 0.25
  const SquadMultiPercent = 0.10
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [currentPage, setCurrentPage] = useState("menu");
  const [LeagueType, setLeagueType] = useState("");
  const [LeagueTypeApi, setLeagueTypeApi] = useState("");

  const IPL_TEAMS =  [
    "PUNJAB",
  "HYDERABAD",
  "LUCKNOW",
  "GUJARAT",
  "KOLKATA",
  "DELHI",
  "BENGALURU",
  "CHENNAI",
  "RAJASTHAN",
  "MUMBAI",
  "CHEPAUK",
  "NELLAI",
  "MADURAI",
  "DINDIGUL",
  "TIRUPPUR",
  "SALEM",
  "COIMBATORE",
  "TRICHY",
  "KOVAI",
  "RATHNAGIRI",
  "NASHIK",
  "SATARA",
  "RAIGAD",
  "PUNERI",
  "KOLHAPUR"
  ];

  const CurrentData = watchScreen?.currentBattleDetails;
  const CurrentMatch = watchScreen?.current_battle;
  const CurrentTeams = CurrentMatch?.teams;
  const selectedTeam = CurrentTeams?.find(
    (team) => team.teamId === CurrentData?.selectedTeamId
  );
  const opponentTeam = CurrentTeams?.find(
    (team) => team.teamId !== CurrentData?.selectedTeamId
  );
  const duration = ipl_BoosterDuration[watchScreen?.ipl_boosterDetails?.name];
  const recentGameScores = useRef([]);
  const playStartTime = useRef(null);
  const totalPlayScore = useRef(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showManualInput, setShowManualInput] = useState(true);
  // let s_oGame = new CGame
  // const currentScore = s_oGame.getScore();
  // console.log("Current Score:", currentScore);

  const getTeamIndex = (teamName) => {
    return IPL_TEAMS.indexOf(teamName);
  };

  const playerTeamIndex = getTeamIndex(selectedTeam?.teamName);
  const opponentTeamIndex = getTeamIndex(opponentTeam?.teamName);
  console.log("playerTeamIndex",playerTeamIndex)
  console.log("opponentTeamIndex",opponentTeamIndex)

  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event) => {
      // Verify the origin of the message for security
      if (event.origin !== window.location.origin) return;

      const { type, data } = event.data;
      const ScoreMulti =
      watchScreen?.ipl_boosterDetails?.name === "2x"
        ? data?.score * 2
        : watchScreen?.ipl_boosterDetails?.name === "3x"
        ? data?.score * 3
        : watchScreen?.ipl_boosterDetails?.name === "4x"
        ? data?.score * 4
        : watchScreen?.ipl_boosterDetails?.name === "5x"
        ? data?.score * 5:
         watchScreen?.ipl_boosterDetails?.name === "comboChain"
                    ? data?.score + (data?.score * ComboPercent) :
                    watchScreen?.ipl_boosterDetails?.name === "squadMultiplier" ?
                    data?.score + (data?.score * SquadMultiPercent)
                      : data?.score;
      switch (type) {
        case "SCORE_UPDATE":
          setScore(data?.score);
          setBallCount(data?.ball);
          setIsGameActive?.(true);
          displaySetScore(ScoreMulti);
          setIsGameStarted(true);
          setCurrentPage(data.currentPage);
          updateUserInfo((prev) => {
            return {
              ...prev,
              ...{
                currentComponentText: data.currentPage,
              },
            };
          });
          break;
        case "GAME_OVER":
          setBallCount(data.ball);
          setIsGameActive?.(false);
          setIsGameStarted(false);
          setCurrentPage(data.currentPage);
          updateUserInfo((prev) => {
            return {
              ...prev,
              ...{
                currentComponentText: data.currentPage,
              },
            };
          });

  // Push score into the queue
  recentGameScores.current.push(ScoreMulti);

  // Keep only the last 3 scores
  if (recentGameScores.current.length > 3) {
    recentGameScores.current.shift();
  }

  // Check if the last 3 games' total score is 100 or more
  const total = recentGameScores.current.reduce((a, b) => a + b, 0);

  if (recentGameScores.current.length === 3 && total >= 100) {
    console.log("🎉 User played 3 games in a row with total score ≥ 100:", total);
    const payload ={
      boosterType : 'comboChain',
    }
    earnRewardInIpl(payload)
    // 👉 Do something here like unlocking a badge, showing reward, etc.
  }


  const elapsedTime = Date.now() - playStartTime.current;

  const hasPlayed10Min = elapsedTime >= 10 * 60 * 1000;
  const has100Score = totalPlayScore.current >= 100;

  if (hasPlayed10Min && has100Score) {
    console.log("🎉 User played more than 10 minutes with total score ≥ 100");
    const payload ={
      minimumTimeSpend : true
    }
    earnRewardInIpl(payload);
    // 👉 Trigger your achievement or reward here
  }


          break;
        case "GAME_START":
          setIsGameActive?.(true);
          setIsGameStarted(true);
          setCurrentPage(data.currentPage);
          updateUserInfo((prev) => {
            return {
              ...prev,
              ...{
                currentComponentText: data.currentPage,
              },
            };
          });
          if (!playStartTime.current) {
            playStartTime.current = Date.now();
            
          }
          
          break;
        case "GAME_PAUSE":
          setIsGameActive?.(false);
          setIsGameStarted(false);
          setCurrentPage(data.currentPage);
          updateUserInfo((prev) => {
            return {
              ...prev,
              ...{
                currentComponentText: data.currentPage,
              },
            };
          });
          break;
          case "PAGE_CHANGE":
            setCurrentPage(data.currentPage);
            updateUserInfo((prev) => {
              return {
                ...prev,
                ...{
                  currentComponentText: data.currentPage,
                },
              };
            });
            // If page changes to menu, update game states
            if (data.currentPage === "menu") {
              setIsGameActive?.(false);
              setIsGameStarted(false);
            }
        default:
          console.log("Unknown message type:", type);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [setScore, setBallCount, setIsGameActive,watchScreen?.ipl_boosterDetails?.name]);
  const [Boostercount, setBoosterCount] = useState(1);

  const boosterItem = watchScreen?.ipl_booster_list?.find(booster => booster.type === watchScreen?.ipl_boosterDetails?.name);

// Get the count (if found, otherwise return 0)
const count = boosterItem ? boosterItem.count : 0;
  const decreaseBoosterCountAndReturnToInventory = () => {
    playClick();
    if (Boostercount === 1||Boostercount==0) {
     return false
    } else {
      var minsBoosterList = watchScreen?.ipl_booster_list;
      minsBoosterList?.forEach((item) => {
        if (item.type === watchScreen?.ipl_boosterDetails?.name ) {
          item.count +=1 ; // Reduce count by 1
          playClick();
        }
      });
      setBoosterCount(Boostercount - 1);
      updatewatchScreenInfo((prev) => {
        return {
          ...prev,
          ...{
            ipl_boosterDetails: {
              ...prev?.ipl_boosterDetails,
              count :Boostercount - 1,
            },
            ipl_booster_list: minsBoosterList,
          },
        };
      });
    }
  };
 
  const takeBoosterFromInventory = () => {

    if (Boostercount>=10 || count==0){
      return false
    }
    playClick();
    setBoosterCount(Boostercount + 1);
  var minsBoosterList = watchScreen?.ipl_booster_list;
    
    minsBoosterList?.forEach((item) => {
      if (item.type === watchScreen?.ipl_boosterDetails?.name && item.count > 0) {
        item.count -=1; // Reduce count by 1
        playClick();
      }
    });
    updatewatchScreenInfo((prev) => {
      return {
        ...prev,
        ...{
          ipl_boosterDetails: {
...prev?.ipl_boosterDetails,
            count :Boostercount + 1,
          },
          ipl_booster_list: minsBoosterList,
        },
      };
    });
  };
  const ActivateBooster =()=>{
    
    if (Boostercount==0 || (!LeagueType && iplBoosterPopup?.type=="fanRally") ){
      return false
    }
      updatewatchScreenInfo((prev) => {
        return {
          ...prev,
          ...{
            ipl_booster: true,
            ipl_boosterDetails: {
              name: watchScreen?.ipl_boosterDetails?.name,
              count :Boostercount
            },
            ipl_boosterSec: duration*Boostercount,
          },
        };
      });
    
      setIplBoosterPopup(false);
      setBoosterCount(1);
  }
  const fetchBoosterList = async () => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const result = await GetIplBoosterList(userDetails?.userDetails?.telegramId);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (result) {
      // setMatchList(result);
      return result; // :white_check_mark: Return result to be used in handleGoToIpl
    } else {
      console.log("Error in MatchScheduleList API");
      return null;
    }
  };
  const closeBoosterPopup= async()=>{
    const boosterRes = await fetchBoosterList();
    if (boosterRes)
    setIplBoosterPopup(false);
    setBoosterCount(1);
    updatewatchScreenInfo((prev) => ({
      ...prev,
      ipl_booster_list: boosterRes?.boosters,
      ipl_booster: false,
      ipl_boosterSec: 0,
      ipl_boosterPoints: 0,
      ipl_boosterDetails: {},
      squadCode:''
    }));
    setLeagueType('');
    setLeagueTypeApi('')
  }


  const BoosterImageFunction =()=>{
  
    if (iplBoosterPopup?.type=="2x"){
      return Images?.twoXIplMarket
    }
    else if (iplBoosterPopup?.type=="3x"){
      return Images?.thirdXIplMarket
    }
    else if (iplBoosterPopup?.type=="5x"){
      return Images?.fiveXIplAMarket
    }
    
    else if (iplBoosterPopup?.type=="4x"){
      return Images?.fourXIplMarket
    }
    else if (iplBoosterPopup?.type=="comboChain"){
      return Images?.comboChain
    }
    else if (iplBoosterPopup?.type=="squadMultiplier"){
      return Images?.squadMultiplier
    }
    else if (iplBoosterPopup?.type=="fanRally"){
      return Images?.fanRally
    }
   
  }
  
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setShowManualInput(!isDropdownOpen);
  };
  const handleSelectLeagueType = (type, type2) => {
    setIsDropdownOpen(false);
    setLeagueType(type);
    setLeagueTypeApi(type2);
    updatewatchScreenInfo((prev) => {
      return {
        ...prev,
        ...{
         squadCode:type2
        },
      };
    });
  
  };
  useEffect(() => {
    logPageView(`${watchScreen?.cricketLeague} Play`,`${watchScreen?.cricketLeague} Play`);
  }, []);
  return (
    
    <div style={{ pointerEvents: "fill" }} className="App">
      {iplBoosterPopup?.status&&
  <div className="overlay">
    <div className="popup">
      <div className="popup-content">
        <>
          <h2 className="text-booster-ipl txt-color">{watchScreen?.ipl_boosterDetails?.name} Booster</h2>
          <img
            src={Images?.cancelIcon}
            className="cancel-img"
            onClick={() => {
              closeBoosterPopup()
        
            }}
          />
          <div className="row text-center">
            <div className="col-12">
              <div className="epic-market">
                {/* {selectedCard && ( */}
                <img
                   src={ BoosterImageFunction()}
                  alt={"booster"}
                  className={"booster1"}
                />
                {/* )} */}
                {/* <h3 className="rw-popup">You got 2x!</h3> */}
            
                <div>
                {iplBoosterPopup?.type=="fanRally"?
                <div className="custom-dropdown">
                <div
                  className={` dropdown-join ${
                    isDropdownOpen ? "active" : ""
                  }`}
                  onClick={toggleDropdown}
                >
                  <span className="selected-text">
                    {LeagueType || "Choose your squad"}
                  </span>
                  <div className="select-arrow"></div>
                </div>

                {isDropdownOpen && (
                  <div className="dropdown-options" style={{maxHeight:"12vh"}}>
                    {SquadList?.map((item)=>
                    <div
                      className="dropdown-item borderjoin"
                      onClick={() =>
                        handleSelectLeagueType(item?.squadName, item?.squadCode)
                      }
                    >
                      {item?.squadName}
                    </div>)}
                   
                  </div>
                )}
              </div>:
                  <div className="buttons">
            
                    <button
                      className="decre txt-color"
                      onClick={decreaseBoosterCountAndReturnToInventory}
                    >
                  
                      <p className="txt-color mb0">-</p>
                    </button>

                    <div>
                    <p className="count">{Boostercount}</p>
                    </div>
                    {Boostercount<=10&&
                    <button className="decre" onClick={takeBoosterFromInventory}>
                      <p className="txt-color mb0">+</p>
                    </button>
}
                  </div>}
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={ActivateBooster}
            className="btn-reward1"
            // style={err === "" ? {} : { color: "white" }}
            // disabled={isLoading}
          >
           Activate Booster
          </button>
          {/* <button className="btn-reward">Free Pick</button> */}
        </>
      </div>
    </div>
    </div>}
       
       
       
    
      {/* Game UI Controls */}
      {/* <div className="game-controls">
        <div className="score-display">Score: {score}</div>
      </div> */}

      <iframe
        src={`/game/index.html?playerTeam=${playerTeamIndex}&opponentTeam=${opponentTeamIndex}`}
        style={{
          height: "65vh",
          border: "none",
          width: "85vw",
          bottom: "0%",
          overflow: "hidden",
        }}
        title="Cricket Game"
        onLoad={(e) => {
          // Send league info to iframe when it loads
          e.target.contentWindow.postMessage({
            type: "INIT_LEAGUE",
            league: watchScreen?.cricketLeague || "ipl"
          }, "*");
        }}
      />
    </div>
  );
};

export default CricketGame;